<template>
  <div class="home-hero" :class="{'home-hero--mobile': deviceType === 'mobile'}">
    <!-- 主 Banner 图片区域 -->
    <div class="home-hero__banner">
      <img :src="bannerSrc" class="home-hero__banner-img" alt="banner placeholder">
      <!-- 渐变遮罩 -->
      <!-- <div class="home-hero__overlay home-hero__overlay--top"></div> -->
      <!-- <div class="home-hero__overlay home-hero__overlay--bottom"></div> -->
    </div>

    <div class="home-hero__container">
      <!-- 车型分类卡片 (Top部分) -->
      <div class="home-hero__categories">
        <a v-for="(cat, index) in categoryCards" :key="index" :href="getCategoryLink(cat.purpose)"
          class="home-hero__category-card">
          <div class="home-hero__category-img-wrapper">
            <div class="home-hero__category-img-bg"></div>
            <img :src="cat.img" class="home-hero__category-img" :alt="cat.name">
          </div>
          <div class="home-hero__category-info">
            <span class="home-hero__category-name">{{ cat.name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
              fill="none">
              <path
                d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
                fill="white" />
            </svg>
          </div>
        </a>
      </div>

      <!-- Banner 文案和按钮 -->
      <div class="home-hero__content">
        <h1 class="home-hero__title">Find Your Perfect Car</h1>
        <AdComponent v-if="$global.isValidAdConfig(adsensConfig?.home_1)"
          ref="ads-home-1" class="home-hero__ad" :ads="adsensConfig?.home_1"
          :showDebug="showDebug" />
        <a :href="getNavLink('/car-list')" class="home-hero__btn">
          <span>Get Started</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="white" />
          </svg>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'HomeHero',
  components: {
    AdComponent
  },
  data () {
    return {
      categoryCards: [
        { name: 'Family Car', purpose: 'Family Vehicle', img: require('@/assets/cate-family.png') },
        { name: 'Commercial Vehicle', purpose: 'Commercial Vehicle', img: require('@/assets/cate-commercial.png') },
        { name: 'Cross Country Vehicle', purpose: 'Cross Country Vehicle', img: require('@/assets/cate-off.png') },
        { name: 'Sports Car', purpose: 'Sport Vehicle', img: require('@/assets/cate-sport.png') }
      ]
    };
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      adsensConfig: 'adsensConfig',
      showDebug: 'showDebug'
    }),
    bannerSrc () {
      // 占位图，实际项目中应从 domainConfig 或 API 获取
      return this.deviceType === 'mobile'
        ? '/background/home/mobile.png'
        : '/background/home/pc.png';
    }
  },
  methods: {
    getNavLink (link) {
      const channel = this.$route.params.channel;
      return channel ? `/${channel}${link}` : link;
    },
    getCategoryLink (name) {
      const channel = this.$route.params.channel;
      const query = `?purpose=${encodeURIComponent(name)}`;
      return channel ? `/${channel}/car-list${query}` : `/car-list${query}`;
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.home-hero {
	position: relative;
	width: 100%;
	background: #000;
	min-height: rem(784);
	overflow: hidden;

	&__banner {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		padding-top: rem(104);
	}

	&__banner-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__overlay {
		position: absolute;
		left: 0;
		width: 100%;
		height: 50%;
		z-index: 2;

		&--top {
			top: 0;
			background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 100%);
		}

		&--bottom {
			bottom: 0;
			background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 100%);
		}
	}

	&__container {
		position: relative;
		z-index: 10;
		padding: 5px rem(180) 0;
		display: flex;
		flex-direction: column;
		gap: rem(40);
	}

	&__categories {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		gap: rem(30);
		width: 100%;
	}

	&__category-card {
		flex: 1;
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		transition: all 0.3s ease;
		text-decoration: none;

		&:hover {
			transform: translateY(-5px);
		}
	}

	&__category-img-wrapper {
		position: relative;
		height: rem(148);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: rem(8);
		height: rem(132);
		aspect-ratio: 59/33;
	}

	&__category-img-bg {
		position: absolute;
		width: 100%;
		height: 100%;
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.3) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		z-index: 1;
	}

	&__category-img {
		position: relative;
		z-index: 2;
		width: 90%;
		height: auto;
		object-fit: contain;
	}

	&__category-info {
		padding: rem(4) rem(16) rem(12) rem(16);
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: transparent;
	}

	&__category-name {
		color: #ffffff;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(14);
		font-weight: 600;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(32);
		width: 100%;
	}

	&__title {
		max-width: rem(600);
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(52);
		line-height: 1.15;
		font-weight: 800;
		margin: 0;
	}

	&__btn {
		background: #e2372d;
		border-radius: rem(12);
		padding: rem(16) rem(32);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: rem(12);
		width: fit-content;
		text-decoration: none;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);
		transition: all 0.3s ease;

		span {
			color: #ffffff;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(16);
			font-weight: 800;
		}

		&:hover {
			background: darken(#e2372d, 10%);
			transform: scale(1.05);
		}
	}

	&__ad {
		width: 100%;
	}

	// @media (max-width: 1200px) {
	// 	&__container {
	// 		padding: rem(80) rem(40) 0;
	// 	}
	// }

	// @media (max-width: 767px) {
	// 	min-height: auto;
	// 	padding-bottom: rem(40);

	// 	&__container {
	// 		padding: rem(100) rem(20) 0;
	// 		gap: rem(30);
	// 	}

	// 	&__categories {
	// 		overflow-x: auto;
	// 		padding-bottom: rem(10);
	// 		&::-webkit-scrollbar {
	// 			display: none;
	// 		}
	// 	}

	// 	&__category-card {
	// 		min-width: rem(200);
	// 	}

	// 	&__title {
	// 		font-size: rem(36);
	// 	}

	// 	&__btn {
	// 		width: 100%;
	// 	}
	// }
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.home-hero {
		min-height: rem(680);
		&__container {
			padding: 5px rem(180) 0;
		}
		&__title {
			font-size: rem(52);
		}
		&__btn {
			width: fit-content;
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.home-hero {
		padding-top: rem(70);
		padding-bottom: rem(40);
		&__banner {
			min-height: rem(720);
			padding-top: 0;
			display: flex;
			align-items: flex-end;
		}

		&__banner-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&__container {
			padding: 0 0 0 rem(20);
			gap: rem(30);
			width: 100%;
		}

		&__content {
			padding-right: rem(20);
		}

		&__categories {
			overflow-x: auto;
			padding-bottom: rem(10);
			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__category-card {
			min-width: rem(200);
		}

		&__title {
			font-size: rem(36);
			color: #fff;
			font-size: rem(52);
			font-style: normal;
			font-weight: 800;
			line-height: rem(60); /* 115.385% */
		}

		
	}
}
</style>
